export default __webpack_public_path__ + "static/media/rx4.e57b07b6.jpeg";